import { createV3Queries } from "@query/utils/createV3Queries";
import { mfaApi } from "@api";

export const queriesMfa = createV3Queries("mfaApi", mfaApi, {
  createMfaFactor: queries => ({
    dependencies: () => [queries.listPersonMfaFactors.queryKeyBase]
  }),
  verifyMfaFactor: queries => ({
    dependencies: () => [queries.listPersonMfaFactors.queryKeyBase]
  }),
  deleteMfaFactor: queries => ({
    dependencies: () => [queries.listPersonMfaFactors.queryKeyBase]
  })
});
